import { ApiResponse, TokenData, DiscountType, DiscountMode } from '../models';
import * as http from './http';
import ApiService from './service';

export class TradeInDiscountTypeService extends ApiService {
  public async loadDiscountType(mode?: string) {
    const url = `${this.apiDomain}/api/discount/type/tradeIn`;

    const resposne = await http.get<ApiResponse<DiscountType[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async updateDiscountType(data: DiscountType, id?: string) {
    const url = `${this.apiDomain}/api/discount/type/tradeIn/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async createDiscountType(data: DiscountType) {
    const url = `${this.apiDomain}/api/discount/type/tradeIn`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteDiscountType(id?: string) {
    const url = `${this.apiDomain}/api/discount/type/tradeIn/${id}`;

    const response = await http.remove<ApiResponse<DiscountType>>(
      url,
      this.store
    );
    return response.data;
  }
  public async updateonModelVariants(
    modelVariants: { modelCode: string; variantCode: string }[],
    id?: string
  ) {
    const url = `${this.apiDomain}/api/discount/type/tradeIn/${id}/model-variants`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      { modelVariants },
      this.store
    );
    return response.data;
  }
  public async getExclusiveTradeInDiscountTypes(id: string) {
    const url = `${this.apiDomain}/api/discount/type/tradeIn/${id}/exclusive`;

    const resposne = await http.get<
      ApiResponse<{ discountTypeId: string; discountMode: string }[]>
    >(url, this.store);
    return resposne?.data?.data;
  }

  public async createDiscountTypeExclusive(
    id: string,
    discountTypeId: string,
    discountMode: DiscountMode
  ) {
    const url = `${this.apiDomain}/api/discount/type/tradeIn/${id}/exclusive`;

    const response = await http.post<ApiResponse<string[]>>(
      url,
      {
        discountTypeId,
        discountMode,
      },
      this.store
    );
    return response.data;
  }

  public async deleteExclusive(
    id: string,
    discountTypeId: string,
    discountMode: DiscountMode
  ) {
    const url = `${this.apiDomain}/api/discount/type/tradeIn/${id}/exclusive/${discountTypeId}/${discountMode}`;

    const response = await http.remove<ApiResponse<string[]>>(url, this.store);
    return response.data;
  }

  public async getCombinedTradeInDiscountTypes(id: string) {
    const url = `${this.apiDomain}/api/discount/type/tradeIn/${id}/combined`;

    const resposne = await http.get<
      ApiResponse<{ discountTypeId: string; discountMode: string }[]>
    >(url, this.store);
    return resposne?.data?.data;
  }

  public async createDiscountTypeCombined(
    id: string,
    discountTypeId: string,
    discountMode: DiscountMode
  ) {
    const url = `${this.apiDomain}/api/discount/type/tradeIn/${id}/combined`;

    const response = await http.post<ApiResponse<string[]>>(
      url,
      {
        discountTypeId,
        discountMode,
      },
      this.store
    );
    return response.data;
  }

  public async deleteCombined(
    id: string,
    discountTypeId: string,
    discountMode: DiscountMode
  ) {
    const url = `${this.apiDomain}/api/discount/type/tradeIn/${id}/combined/${discountTypeId}/${discountMode}`;

    const response = await http.remove<ApiResponse<string[]>>(url, this.store);
    return response.data;
  }
}
